import { useEffect, useState } from "react";
import {
  Box,
  OutlinedInput,
  InputLabel,
  MenuItem,
  FormControl,
  Select,
  Chip,
} from "@mui/material";
import { namesChords } from "utils/Chords";
import useLocales from "hooks/useLocales";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function MultipleSelectChip({ setChordsSelected }) {
  const [chordName, setChordName] = useState([]);
  const { translate } = useLocales();

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setChordName(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };

  useEffect(() => {
    setChordsSelected(chordName);
  }, [chordName, setChordsSelected]);

  return (
    <div>
      <FormControl fullWidth sx={{ m: 1, minWidth: 250 }}>
        <InputLabel id="*multiple-chip-label">{translate("Chords")}</InputLabel>
        <Select
          labelId="*multiple-chip-label"
          id="*multiple-chip"
          multiple
          value={chordName}
          onChange={handleChange}
          input={<OutlinedInput id="select-multiple-chip" label="Accords" />}
          renderValue={(selected) => (
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
              {selected.map((value) => {
                return (
                  <Chip
                    key={Object.entries(value)[0][0]}
                    label={translate(Object.entries(value)[0][0])}
                  />
                );
              })}
            </Box>
          )}
          MenuProps={MenuProps}
        >
          {namesChords.map((name) => (
            <MenuItem key={Object.entries(name)[0][0]} value={translate(name)}>
              {translate(Object.entries(name)[0][0])}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}
